"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var conditions_1 = require("../common/conditions");
var _1 = require(".");
var ConditionFactory = /** @class */ (function () {
    function ConditionFactory(settings, skillService, visitService, optionsService, notificationService) {
        this.settings = settings;
        this.skillService = skillService;
        this.visitService = visitService;
        this.optionsService = optionsService;
        this.notificationService = notificationService;
        this.conditionGenerators = new Map();
        this.initConditionsRegistry();
    }
    ConditionFactory.prototype.addCondition = function (name, conditionGenerator) {
        this.conditionGenerators.set(name, conditionGenerator);
    };
    ConditionFactory.prototype.getCondition = function (name, applicationOptions, conditionOptions) {
        var generator = this.conditionGenerators.get(name);
        if (!generator)
            throw new Error("Unsupported condition: '" + name + ".");
        var condition = generator(applicationOptions, conditionOptions);
        return condition;
    };
    ConditionFactory.prototype.initConditionsRegistry = function () {
        var _this = this;
        this.addCondition('DurationSpentOnPage', function (ao, co) { return new conditions_1.TimeSpentCondition(co, _this.notificationService); });
        this.addCondition('TimeSinceLastInviteBySite', function (ao, co) { return new conditions_1.TimeSinceLastInviteBySiteCondition(_this.settings.lastInvitationTimestamp, co, _this.notificationService); });
        this.addCondition('PageCount', function (ao, co) { return new conditions_1.PageCountCondition(ao.Location, _this.visitService.visits, co, _this.notificationService); });
        this.addCondition('PageCountBySite', function (ao, co) { return new conditions_1.PageCountBySiteCondition(_this.visitService.visits, co, _this.notificationService); });
        this.addCondition('SkillAvailable', function (ao, co) { return new conditions_1.SkillAvailableCondition(ao, _this.skillService, _this.notificationService); });
        this.addCondition('WithdrawTimeout', function (ao, co) { return new conditions_1.WithdrawInvitationCondition(co, _this.notificationService); });
        this.addCondition('TimeSinceLastVisitByPage', function (ao, co) { return new conditions_1.TimeSinceLastVisitByPageCondition(ao.Location, _this.visitService.visits, co, _this.notificationService); });
        this.addCondition('ProactiveFormTagValid', function (ao, co) { return new conditions_1.ProactiveFormTagValidCondition(_this.optionsService, ao.FormTagName, _this.notificationService); });
    };
    return ConditionFactory;
}());
exports.ConditionFactory = ConditionFactory;
